/* eslint no-param-reassign:0, no-script-url:0, */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class RtfContent extends PureComponent {
  constructor(props) {
    super(props);

    this.setRtfContent = iframe => {
      if (!iframe) return;

      const window = iframe.contentWindow;
      const { document } = window;
      const { body, documentElement: html = body } = document;
      const { rtfContent } = this.props;

      window.adjustParentWindowHeight = () => {
        iframe.height = '';
        const originalHeight = Math.max(
          body.scrollHeight,
          body.offsetHeight,
          html.clientHeight,
          html.scrollHeight,
          html.offsetHeight,
        );
        iframe.height = `${originalHeight + 20}px`;
      };

      body.style.overflowY = 'hidden';
      body.innerHTML = rtfContent
        .replace(
          /(<img)([^>]*>)/gi,
          '$1 onload="adjustParentWindowHeight()" onerror="adjustParentWindowHeight()"$2',
        )
        .replace(/<a(\s[^>]*)?>/gim, str =>
          str
            .replace(/\starget(=("[^"]*"|'[^']*'))?/i, '')
            .replace(/(<a)(\s[^>]*)?(>)/i, '$1 target="_blank"$2$3'),
        );

      window.adjustParentWindowHeight();
    };
  }

  render() {
    const { title } = this.props;
    return (
      <iframe
        eb-test="ee_notificationDetail_iframe_rtfcontent"
        ref={this.setRtfContent}
        title={title}
        src={
          /(MSIE )|(Trident\/)|(Edge\/)|Chrome/.test(window.navigator.userAgent)
            ? ''
            : 'javascript:void(0)'
        }
        hspace="0"
        vspace="0"
        marginWidth="0"
        marginHeight="0"
        frameBorder="0"
        width="100%"
      />
    );
  }
}

RtfContent.propTypes = {
  title: PropTypes.string.isRequired,
  rtfContent: PropTypes.string.isRequired,
};

export default RtfContent;
